
import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { MatIconAnchor } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheck, faClose } from '@fortawesome/free-solid-svg-icons';
import { ApiServicesService } from '../services/api-services.service';
import { SnackbarService } from '../services/snackbar.service';
import { Router } from '@angular/router';
import { SocketService } from '../services/socket.service';
import { UserDetailsService } from '../services/user-details.service';

@Component({
  selector: 'app-custom-snackbar',
  standalone: true,
  imports: [MatIconAnchor, CommonModule, FontAwesomeModule],
  templateUrl: './custom-snackbar.component.html',
  styleUrl: './custom-snackbar.component.css'
})

export class CustomSnackbarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any, public api: ApiServicesService, private snackbarService: SnackbarService, private router: Router, private socketService: SocketService, private headerUpdateService: UserDetailsService) {

    // console.log('this.data', this.data);
    if (this.data?.message == 'Your account is inactive. Cannot perform this action.' || this.data?.message == 'Authorization Failed. Auth Token is Invalid') {
      // console.log('this.data', this.data)
      // this.api.logout().subscribe({
      //   next: (response) => {
      //     this.snackbarService.openCustomSnackbar(
      //       {
      //         icon: true,
      //         message: response.message,
      //         className: 'success',
      //       }
      //     );

      //   },
      //   error: (error) => { }
      // })
      this.router.navigate(['']);
      localStorage.removeItem("encryptedUserData");
      this.api.removeheaders();
      this.socketService.disconnect();
      this.headerUpdateService.triggerHeaderUpdate();
    };
  }
  faCheck = faCheck;
  faCancel = faClose;
}
